"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios"));

var RETRY_STATUS_CODE = 206;
var RETRY_WAIT_TIME = 1000;

var StoriesAPIClient = function () {
  function StoriesAPIClient(baseUrl, apiKey) {
    this.baseUrl = baseUrl;
    this.apiKey = apiKey;
    this.client = this.buildClient();
  }

  StoriesAPIClient.prototype.buildClient = function () {
    var _this = this;

    var storyAPIRequest = axios_1.default.create();

    var sleepRequest = function sleepRequest(milliseconds, originalRequest) {
      return new Promise(function (resolve) {
        return setTimeout(function () {
          return resolve(storyAPIRequest(originalRequest));
        }, milliseconds);
      });
    };

    storyAPIRequest.interceptors.request.use(function (config) {
      var _a;

      var updatedConfig = __assign({}, config); // Set API Key


      updatedConfig.headers.Authorization = "Api-Key " + _this.apiKey; // Parse slug with base url

      if (!((_a = updatedConfig.url) === null || _a === void 0 ? void 0 : _a.startsWith('http'))) {
        updatedConfig.url = _this.baseUrl + "/api/" + updatedConfig.url;
      }

      return updatedConfig;
    });
    storyAPIRequest.interceptors.response.use(function (response) {
      var config = response.config,
          data = response.data,
          status = response.status;

      if (status === RETRY_STATUS_CODE && data && data.retry_url) {
        var newConfig = __assign({}, config);

        newConfig.url = data.retry_url;
        newConfig.params = {};
        return sleepRequest(RETRY_WAIT_TIME, newConfig);
      }

      return data;
    });
    return storyAPIRequest;
  };

  StoriesAPIClient.prototype.request = function (slug, callback, err) {
    return this.client.get(slug).then(function (data) {
      return callback && callback(data);
    }, function (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return err && err(error);
    });
  };

  StoriesAPIClient.prototype.story = function (slug, collection, page, q, callback, err) {
    var newSlug = slug;

    if (collection != null) {
      newSlug += "?collection=" + collection;

      if (page) {
        newSlug += "&page=" + page;
      }

      if (q) {
        newSlug += "&q=" + q;
      }
    }

    return this.request("story/" + newSlug, callback, err);
  };

  StoriesAPIClient.prototype.collection = function (slug, callback, err) {
    return this.request("collection/" + slug, callback, err);
  };

  return StoriesAPIClient;
}();

exports.default = StoriesAPIClient;